import { ClosePopup, OpenPopup } from "../actions/ui";
import { SetTerminalPopupLauncher } from "../actions/terminal";
import {
    LOGIN_ADMIN, SET_LANGUAGE, CASHOUT_MONEY, CASHOUT_MONEY_CASH, CASHOUT_CLIENT_MONEY, SET_BALANCE, PRINT_TICKET, PRINT_CLIENT_TICKET, ADMIN_PAGE_EXIT, SHUT_DOWN,
    PRINT_LAST_TICKET, PRINT_LAST_CASH_OUT_TICKET, STACKER_COLLECTION, REBOOT_PC, OPEN_LAST_LOG_FILE,
    RESET_UI_BY_IDLE_TIMER, LAST_ENTERED_BILL_AND_COINS, LOCK_TERMINAL_ADMIN, UNLOCK_TERMINAL_ADMIN, RESET_BILL_ACCEPTOR, NOTE_RECYCLER,
    RESET_DEVICE_CONNECTION, CLOSE_APP_LOCATION, TODAYS_REPORT, REMOVE_STACKER_BALANCE, SHOW_STACKER_BALANCE,
    UPPER_SCREEN, TICKET_IN, TITO_ACCEPT_BET, TITO_CASHOUT_BET, ADD_TO_BALANCE, TERMINAL_ERROR, SEND_LOGS, TITO_ACCEPT_CASHOUT, LOCK_TERMINAL, UNLOCK_TERMINAL, GET_LAST_TICKETS, GET_LAST_TICKET_BY_ID,
    GET_LAST_PAYED_TICKETS, HIDE_TERMINAL_ERROR, SET_TAX, USER_DID_LOGIN, USER_DID_LOGOUT, MOUSE_MOVE_POSITION, SHOW_DEVICE_STATUS, PRINT_LAST_PAYED_TICKETS, PRINT_LOTTERY_TICKET,
    SET_HOPPER_1_VALUE, SET_HOPPER_2_VALUE, CHECK_HOPPERS_ERRORS_AND_STATES, DO_CONFIRM, CLEAR_USER_ID, FINISH_DEPOSIT, REGISTER_MODE, CONFIRM_REGISTRATION_NEW_CARD, UPDATE_PLAYER_CARD_ID, PAY_CASINO_LOTTERY_WIN_TICKET, PRINT_BOOKING_TICKET, GET_SUPERBET_TICKET_BY_ID, SET_SUPERBET_ID, REJECT_SUPERBET, CASINO_GAMES_OPENED, RFID_REGISTER_MODE, MULTIPLEDAYS_REPORT, CASHOUT_MONEY_WITH_FEE, DEPOSIT, DEPOSIT_TO_CLIENT_ACCOUNT, PRINT_BET_BUILDER_TICKET, ADMIN_USER_COMMANDS
} from "../actions/actionTypes";
import Config from "../config/main";
import IdleService from '../services/idle';
const terminalMiddleWare = store => next => action => {
    let data = action.payload;
    window.jsobject = window.jsobject || window.external || {};
    switch (action.type) {
        case LOGIN_ADMIN:
            window.jsobject.loginAdmin(data.username, data.password);
            break;
        case TICKET_IN:
            store.dispatch(OpenPopup("ticket-in", { data }));
            break;
        case PAY_CASINO_LOTTERY_WIN_TICKET:
            window.jsobject.titoAcceptCasinoBet(data.data.WinId.toString(), data.data.WinAmount, data.userData ? data.userData : null, 0);
            break;
        case ADD_TO_BALANCE:
            window.jsobject.bulkTitoOperation(JSON.stringify(data));
            break;
        case NOTE_RECYCLER:
            window.jsobject.openNoteFloatWindow();
            break;
        case USER_DID_LOGIN:
            window.jsobject.userDidLogin(data.userId, data.currency);
            break;
        case USER_DID_LOGOUT:
            window.jsobject.userDidLogout();
            break;
        case REGISTER_MODE:
            window.jsobject.registerMode(data);
            break;
        case CONFIRM_REGISTRATION_NEW_CARD:
            window.jsobject.confirmRegistrationNewCard(data);
            break;
        case UPDATE_PLAYER_CARD_ID:
            window.jsobject.updatePlayerCardId(data);
            break;
        case TITO_ACCEPT_BET:
            window.jsobject.titoAcceptBet(data.barcode, data.amount, data.tax_amount, data.inputData ? data.inputData : null);
            break;
        // TODO delete after all partners get MultiplePopup
        case TITO_CASHOUT_BET:
            if (Config.enableMultipleWinsPopup) {
                window.jsobject.titoCashoutBetFromTicketsBoard(data.barcode, data.amount, data.inputData ? data.inputData : null);
            } else {
                window.jsobject.titoCashoutBet(data.barcode, data.amount, data.inputData ? data.inputData : null);
            }
            break;
        case GET_LAST_TICKET_BY_ID:
            window.jsobject.getLastTicketById(data);
            break;
        case GET_SUPERBET_TICKET_BY_ID:
            window.jsobject.getSuperbetTicketById(data);
            break;
        case SET_SUPERBET_ID:
            window.jsobject.setSuperBetId(data);
            break;
        case REJECT_SUPERBET:
            window.jsobject.rejectSuperbet(data);
            break;
        case GET_LAST_PAYED_TICKETS:
            window.jsobject.getLastPaidTickets(data.date);
            break;
        case PRINT_LAST_PAYED_TICKETS:
            window.jsobject.printLastPaidTickets();
            break;
        case SET_LANGUAGE:
            window.jsobject.setLanguage(data);
            break;
        case RESET_UI_BY_IDLE_TIMER:
            window.jsobject.resetUiByIdleTimer();
            break;
        case MOUSE_MOVE_POSITION:
            IdleService.resetTimer();
            window.jsobject.touchPosition(data.x, data.y);
            break;
        case LOCK_TERMINAL:
            store.dispatch(SetTerminalPopupLauncher({
                terminalError: false,
                lockTerminal: true
            }));
            store.dispatch(OpenPopup("lockTerminal", { data, disable: true }));
            break;
        case UNLOCK_TERMINAL:
            if (store.getState().terminal.popupLauncher && store.getState().terminal.popupLauncher.lockTerminal) {
                store.dispatch(SetTerminalPopupLauncher(null));
                store.dispatch(ClosePopup("loginAdmin"));
                store.dispatch(ClosePopup("lockTerminal"));
            }
            break;
        case TERMINAL_ERROR:
            store.dispatch(SetTerminalPopupLauncher({
                terminalError: true,
                lockTerminal: false
            }));
            store.dispatch(OpenPopup("terminal-error", { data, disable: data.close }));
            break;
        case HIDE_TERMINAL_ERROR:
            if (store.getState().terminal.popupLauncher.terminalError) {
                store.dispatch(SetTerminalPopupLauncher(null));
                store.dispatch(ClosePopup("loginAdmin"));
                store.dispatch(ClosePopup("terminal-error"));
            }
            break;
        case SEND_LOGS:
            window.jsobject.sendLogs(JSON.stringify(data));
            break;
        case CASHOUT_MONEY:
            window.jsobject.withdraw(1);
            break;
        case CASHOUT_MONEY_CASH:
            window.jsobject.withdraw(2);
            break;
        case CASHOUT_MONEY_WITH_FEE:
            window.jsobject.withdrawWithFee(2);
            break;
        case CASHOUT_CLIENT_MONEY:
            window.jsobject.withdrawClientBalance();
            break;
        case TITO_ACCEPT_CASHOUT:
            window.jsobject.titoAcceptCashout(data.docId.toString(), data.amount);
            break;
        case SET_BALANCE:
            window.jsobject.setBalance(data);
            break;
        case PRINT_TICKET:
            window.jsobject.printTicket(data);
            break;
        case PRINT_BET_BUILDER_TICKET:
            window.jsobject.printBetBuilderTicket(data);
            break;
        case PRINT_CLIENT_TICKET:
            window.jsobject.printClientTicket(data);
            break;
        case PRINT_LOTTERY_TICKET:
            window.jsobject.printLotteryTickets(data, action.isCopy);
            break;
        case CASINO_GAMES_OPENED:
            window.jsobject.casinoGamesPageOpened();
            break;
        case PRINT_BOOKING_TICKET:
            window.jsobject.printBookingTicket(data);
            break;
        case ADMIN_PAGE_EXIT:
            window.jsobject.adminPageExit();
            break;
        case SHUT_DOWN:
            window.jsobject.shutDown();
            break;
        case PRINT_LAST_TICKET:
            window.jsobject.printLastTicket();
            break;
        case PRINT_LAST_CASH_OUT_TICKET:
            window.jsobject.printLastCashoutTicket();
            break;
        case STACKER_COLLECTION:
            window.jsobject.stackerCollection();
            break;
        case REBOOT_PC:
            window.jsobject.rebootPC();
            break;
        case OPEN_LAST_LOG_FILE:
            window.jsobject.openLastLogFile();
            break;
        case LAST_ENTERED_BILL_AND_COINS:
            window.jsobject.lastEnteredBillsAndCoins();
            break;
        case LOCK_TERMINAL_ADMIN:
            window.jsobject.lockTerminal();
            break;
        case UNLOCK_TERMINAL_ADMIN:
            window.jsobject.unlockTerminal();
            break;
        case RESET_BILL_ACCEPTOR:
            window.jsobject.resetBillAcceptor();
            break;
        case RESET_DEVICE_CONNECTION:
            window.jsobject.resetDeviceConnections();
            break;
        case SHOW_DEVICE_STATUS:
            window.jsobject.showDeviceStatuses();
            break;
        case CHECK_HOPPERS_ERRORS_AND_STATES:
            window.jsobject.checkHoppersErrorsAndStates();
            break;
        case SET_HOPPER_1_VALUE:
            window.jsobject.hopper1Refill(data);
            break;
        case SET_HOPPER_2_VALUE:
            window.jsobject.hopper2Refill(data);
            break;
        case CLOSE_APP_LOCATION:
            window.jsobject.closeApplication();
            break;
        case TODAYS_REPORT:
            window.jsobject.todaysReport(data);
            break;
        case MULTIPLEDAYS_REPORT:
            window.jsobject.multipleDaysReport(data.start, data.end);
            break;
        case GET_LAST_TICKETS:
            window.jsobject.getLastTickets(data);
            break;
        case REMOVE_STACKER_BALANCE:
            window.jsobject.stackerBalance();
            break;
        case SHOW_STACKER_BALANCE:
            window.jsobject.showStackerBalance();
            break;
        case UPPER_SCREEN:
            window.jsobject.upperScreen(data.type, data.id, data.videoURL, data.tv_type);
            break;
        case SET_TAX:
            (data.taxType) && window.jsobject.setTax(data.taxType, data.taxPercent);
            break;
        case DO_CONFIRM:
            window.jsobject.confirmUserId(data);
            break;
        case CLEAR_USER_ID:
            window.jsobject.clearUserId();
            break;
        case FINISH_DEPOSIT:
            window.jsobject.finishDeposit();
            break;
        case RFID_REGISTER_MODE:
            window.jsobject.rfidRegisterMode(action.mode, JSON.stringify(action.payload))
            break;
        case ADMIN_USER_COMMANDS:
            window.jsobject.adminUserCommands(action.command, JSON.stringify(action.payload))
            break;
        case DEPOSIT:
            window.jsobject.cardDeposit(action.payload)
            break;
        case DEPOSIT_TO_CLIENT_ACCOUNT:
            window.jsobject.depositToClientAccount(action.clientId)
        default:
            next(action);
    }
};

export default terminalMiddleWare;
